module.exports = __webpack_public_path__ + "img/risk-icon.56769d71.svg";